import React, { useState } from 'react';
import {
  ImageBackground,
  StyleSheet,
  Text as NativeText,
  TouchableOpacity,
  View,
} from 'react-native';
import Modal from 'modal-enhanced-react-native-web';
import { Link } from '@react-navigation/native';
import { LinearGradient } from 'expo-linear-gradient';
import { useSelector } from 'react-redux';

import CheckBox from '../../components/checkbox';
import FooterLanding from '../../components/footerComponentLanding/customFooter';
import TextInputComponent from '../../components/textinput/TextInputComponent';
import MainDrawerMenu from '../hello/MainDrawer';
import { Header } from '../hello/header';
import rightImg from '../../assets/images/forgotImage.png';
import ajax from '../../helpers/ajaxHelper';
import getPlatformType from '../../helpers/helpers';
import {
  EmailValidation,
  NameValidation,
  PasswordComparisonValidation,
  PasswordValidation,
} from '../../helpers/validation';
import Urls from '../../services/Urls';
import { showSuccesToast } from '../tenants/tenantOnboarding/helpers';

const registerPhoneTitle = 'Create your Hubita account';
const registerPhoneSubtitle =
  'Register to manage your properties';
const registerPhonePrimaryLabel = 'Create account';
const registerPhoneSecondaryLabel = 'Already have an account? Sign in';

const registerDesktopTitle = 'Create your Hubita account';
const registerDesktopSubtitle =
  'Register to manage your properties';
const registerDesktopPrimaryLabel = 'Create account';
const registerDesktopSecondaryLabel = 'Already have an account?';
const registerDesktopSecondaryActionLabel = 'Login';
const registerDesktopHeroPrompt = 'Already have an account?';
const registerDesktopHeroPromptAction = 'Login';
const registerDesktopHeroEyebrow = 'Built for self-managing landlords';
const registerDesktopHeroTitle = 'Everything your property needs. One simple hub — always in your control.';
const registerDesktopHeroText =
  'Join Hubita to manage reminders, rent, documents and tenant activity in one secure place — giving you clarity, confidence and control over every part of your rental journey.';

const registerPhoneHighlights = [
  'Stay in control with all your property information in one central hub',
  'Stay compliant and organised with clear reminders and tasks',
  'Enjoy peace of mind, knowing everything is securely managed and easy to find Hubita. Landlord life. Simplified.',

];

const registerDesktopHighlights =[
  'Stay in control with all your property information in one central hub',
  'Stay compliant and organised with clear reminders and tasks',
  'Enjoy peace of mind, knowing everything is securely managed and easy to find Hubita. Landlord life. Simplified.',

];

const RegisterScreen = ({ navigation }) => {
  const layoutType = getPlatformType();
  const isPhone = layoutType === 'phone';
  const userToken = useSelector((state) => state?.AppReducer?.token);
  const [openDrawer, setDrawer] = useState(false);

  const [first_name, setFirstName] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  const [last_name, setLastName] = useState('');
  const [contact_no, setContact] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passError, setPassError] = useState('');
  const [confirm_pass, setConfirmPass] = useState('');
  const [confirmPassError, setConfirmPassError] = useState('');
  const [tncStatus, setTncStatus] = useState(false);
  const [tncStatusError, setTncStatusError] = useState('');

  const terms = (
    <>
      I accept Hubita{' '}
      <NativeText style={styles.termsLink}>
        <Link to="https://dev.hubita.co.uk/legal-bits" target="_blank">
          T&amp;Cs
        </Link>
      </NativeText>{' '}
      and{' '}
      <NativeText style={styles.termsLink}>
        <Link to="https://dev.hubita.co.uk/legal-bits" target="_blank">
          privacy policy
        </Link>
      </NativeText>
    </>
  );

  const callRegistrationAPI = () => {
    const requestBody = {
      email,
      password,
      first_name,
      last_name,
      contact_number: contact_no,
    };

    ajax
      .post(Urls.RegistrationAPI, requestBody)
      .then(({ data }) => {
        if (data.status) {
          showSuccesToast('Your account created successfully, please login');
          navigation.navigate('login');
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const onRegister = () => {
    const firstNameValidate = NameValidation(first_name);
    const emailValidate = EmailValidation(email);
    const passwordValidate = PasswordValidation(password);
    const confirmPassValidate = PasswordComparisonValidation(password, confirm_pass);

    if (
      firstNameValidate.status &&
      tncStatus &&
      emailValidate.status &&
      passwordValidate.status &&
      confirmPassValidate.status
    ) {
      callRegistrationAPI();
      return;
    }

    setFirstNameError(firstNameValidate?.status ? '' : firstNameValidate.msg);
    setEmailError(emailValidate?.status ? '' : emailValidate.msg);
    setPassError(passwordValidate?.status ? '' : passwordValidate.msg);
    setConfirmPassError(confirmPassValidate?.status ? '' : confirmPassValidate.msg);
    setTncStatusError(tncStatus ? '' : 'Please accept the terms above.');
  };

  const formFields = (
    <>
      <TextInputComponent
        error={firstNameError}
        title="First Name"
        onChangeText={(value) => {
          setFirstName(value);
          setFirstNameError('');
        }}
        colored
      />
      <TextInputComponent
        title="Last Name"
        onChangeText={(value) => setLastName(value)}
        colored
      />
      <TextInputComponent
        isNumeric
        maxLength={12}
        title="Contact Number"
        onChangeText={(value) => setContact(value)}
        value={contact_no}
        colored
      />
      <TextInputComponent
        error={emailError}
        title="Email Address"
        onChangeText={(value) => {
          setEmail(value);
          setEmailError('');
        }}
        colored
      />
      <TextInputComponent
        error={passError}
        password
        renderRightComponent
        title="Password"
        onChangeText={(value) => {
          setPassword(value);
          setPassError('');
        }}
        colored
      />
      <TextInputComponent
        error={confirmPassError}
        password
        renderRightComponent
        title="Confirm Password"
        onChangeText={(value) => {
          setConfirmPass(value);
          setConfirmPassError('');
        }}
        colored
      />
    </>
  );

  const termsBlock = (
    <View style={styles.checkboxWrap}>
      <CheckBox
        id="registerCheckbox-1"
        checked={tncStatus}
        label={terms}
        onPress={() => {
          setTncStatus(!tncStatus);
          setTncStatusError('');
        }}
      />
      {!!tncStatusError && <NativeText style={styles.errorText}>{tncStatusError}</NativeText>}
    </View>
  );

  const publicRegisterContent = isPhone ? (
    <View style={styles.mobilePublicWrap}>
      <View style={styles.mobileFormCard}>
        <NativeText style={[styles.publicTitle, styles.mobilePublicTitle]}>
          {registerPhoneTitle}
        </NativeText>
        <NativeText style={[styles.publicSubtitle, styles.mobilePublicSubtitle]}>
          {registerPhoneSubtitle}
        </NativeText>

        <View style={[styles.publicInputsWrap, styles.mobileInputsWrap]}>{formFields}</View>

        {termsBlock}

        <LinearGradient
          colors={['#2C8EF4', '#5C59E8']}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={[styles.primaryAction, styles.primaryActionMobile]}
        >
          <TouchableOpacity onPress={onRegister} style={styles.primaryActionTouch} activeOpacity={0.9}>
            <NativeText style={styles.primaryActionText}>{registerPhonePrimaryLabel}</NativeText>
          </TouchableOpacity>
        </LinearGradient>

        <TouchableOpacity
          onPress={() => navigation.navigate('login')}
          style={styles.mobileSecondaryAction}
          activeOpacity={0.9}
        >
          <NativeText style={styles.mobileSecondaryActionText}>{registerPhoneSecondaryLabel}</NativeText>
        </TouchableOpacity>

        <View style={styles.mobileHighlightList}>
          {registerPhoneHighlights.map((item) => (
            <View key={item} style={styles.mobileHighlightItem}>
              <View style={styles.mobileHighlightDot} />
              <NativeText style={styles.mobileHighlightText}>{item}</NativeText>
            </View>
          ))}
        </View>
      </View>
    </View>
  ) : (
    <View style={styles.publicShell}>
      <View style={styles.publicCard}>
        <View style={styles.publicLeftPanel}>
          <View style={styles.publicFormCardInner}>
            <NativeText style={styles.publicTitle}>{registerDesktopTitle}</NativeText>
            <NativeText style={styles.publicSubtitle}>{registerDesktopSubtitle}</NativeText>

            <View style={styles.publicInputsWrap}>{formFields}</View>

            {termsBlock}

            <View style={styles.publicFooterRow}>
              <LinearGradient
                colors={['#2C8EF4', '#5C59E8']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                style={styles.primaryAction}
              >
                <TouchableOpacity onPress={onRegister} style={styles.primaryActionTouch} activeOpacity={0.9}>
                  <NativeText style={styles.primaryActionText}>{registerDesktopPrimaryLabel}</NativeText>
                </TouchableOpacity>
              </LinearGradient>

              <TouchableOpacity
                onPress={() => navigation.navigate('login')}
                style={styles.desktopSecondaryButton}
                activeOpacity={0.85}
              >
                <NativeText style={styles.desktopSecondaryButtonText}>
                  {registerDesktopSecondaryLabel} {registerDesktopSecondaryActionLabel}
                </NativeText>
              </TouchableOpacity>
            </View>
          </View>
        </View>

        <ImageBackground source={rightImg} style={styles.publicRightPanel} imageStyle={styles.publicRightImage}>
          <LinearGradient
            colors={['rgba(27,42,78,0.92)', 'rgba(76,74,219,0.78)', 'rgba(204,88,227,0.62)']}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={styles.publicOverlay}
          >
            <View style={styles.publicTopAction}>
              <NativeText style={styles.publicTopActionText}>{registerDesktopHeroPrompt}</NativeText>
              <TouchableOpacity
                onPress={() => navigation.navigate('login')}
                style={styles.secondaryAction}
                activeOpacity={0.9}
              >
                <NativeText style={styles.secondaryActionText}>{registerDesktopHeroPromptAction}</NativeText>
              </TouchableOpacity>
            </View>

            <View style={styles.publicHeroCopy}>
              <NativeText style={styles.publicHeroEyebrow}>{registerDesktopHeroEyebrow}</NativeText>
              <NativeText style={styles.publicHeroTitle}>{registerDesktopHeroTitle}</NativeText>
              <NativeText style={styles.publicHeroText}>{registerDesktopHeroText}</NativeText>

              <View style={styles.desktopHighlightList}>
                {registerDesktopHighlights.map((item) => (
                  <View key={item} style={styles.desktopHighlightItem}>
                    <View style={styles.desktopHighlightDot} />
                    <NativeText style={styles.desktopHighlightText}>{item}</NativeText>
                  </View>
                ))}
              </View>
            </View>
          </LinearGradient>
        </ImageBackground>
      </View>
    </View>
  );

  if (!userToken) {
    return (
      <View style={styles.screen}>
        <Header setDrawer={() => setDrawer(true)} />
        <View style={styles.content}>{publicRegisterContent}</View>
        <FooterLanding navigation={navigation} />
        <Modal
          isVisible={openDrawer}
          animationIn="slideInRight"
          animationOut="slideOutRight"
          animationInTiming={300}
          animationOutTiming={300}
          coverScreen={false}
          hasBackdrop={false}
          backdropOpacity={0}
          onBackdropPress={() => setDrawer(false)}
          style={{ margin: 0, width: '100%', right: 0 }}
        >
          <View style={styles.drawerWrap}>
            <MainDrawerMenu setDrawer={setDrawer} />
          </View>
        </Modal>
      </View>
    );
  }

  return <View style={styles.screen}>{publicRegisterContent}</View>;
};

export default RegisterScreen;

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: '#F7F9FC',
  },
  content: {
    flex: 1,
  },
  publicShell: {
    flex: 1,
    paddingHorizontal: 28,
    paddingVertical: 26,
    backgroundColor: '#F7F9FC',
  },
  publicCard: {
    flex: 1,
    minHeight: 720,
    backgroundColor: '#FFFFFF',
    borderRadius: 20,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#E6EAF2',
    shadowColor: '#101828',
    shadowOpacity: 0.08,
    shadowRadius: 24,
    shadowOffset: { width: 0, height: 12 },
    elevation: 4,
    flexDirection: 'row',
  },
  publicLeftPanel: {
    width: '48%',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 40,
    paddingVertical: 36,
  },
  publicFormCardInner: {
    width: '100%',
    maxWidth: 520,
    paddingVertical: 12,
  },
  publicTitle: {
    fontFamily: 'poppins',
    fontWeight: '700',
    fontSize: 44,
    lineHeight: 52,
    color: '#1B2559',
    maxWidth: 460,
  },
  publicSubtitle: {
    fontFamily: 'roboto-light',
    fontSize: 17,
    lineHeight: 28,
    color: '#667085',
    marginTop: 14,
    maxWidth: 470,
  },
  publicInputsWrap: {
    marginTop: 22,
    gap: 12,
  },
  publicFooterRow: {
    marginTop: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  checkboxWrap: {
    marginTop: 14,
  },
  errorText: {
    marginTop: 6,
    color: '#DC2626',
    fontSize: 13,
    lineHeight: 18,
    fontFamily: 'roboto-light',
  },
  primaryAction: {
    minWidth: 170,
    height: 54,
    borderRadius: 14,
    overflow: 'hidden',
    shadowColor: '#4258DB',
    shadowOpacity: 0.24,
    shadowRadius: 14,
    shadowOffset: { width: 0, height: 8 },
    elevation: 3,
  },
  primaryActionTouch: {
    minWidth: 170,
    height: 54,
    paddingHorizontal: 28,
    justifyContent: 'center',
    alignItems: 'center',
  },
  primaryActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 20,
    color: '#FFFFFF',
  },
  desktopSecondaryButton: {
    paddingVertical: 12,
    paddingHorizontal: 8,
  },
  desktopSecondaryButtonText: {
    fontFamily: 'poppins-medium',
    fontSize: 15,
    lineHeight: 22,
    color: '#4258DB',
  },
  publicRightPanel: {
    width: '52%',
    minHeight: 720,
    justifyContent: 'space-between',
    backgroundColor: '#25125F',
  },
  publicRightImage: {
    resizeMode: 'cover',
  },
  publicOverlay: {
    flex: 1,
    paddingHorizontal: 38,
    paddingVertical: 34,
    justifyContent: 'space-between',
  },
  publicTopAction: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  publicTopActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 20,
    lineHeight: 28,
    color: '#FFFFFF',
    marginRight: 18,
  },
  secondaryAction: {
    height: 50,
    paddingHorizontal: 28,
    borderRadius: 14,
    borderWidth: 2,
    borderColor: 'rgba(255,255,255,0.9)',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  secondaryActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 22,
    color: '#FFFFFF',
  },
  publicHeroCopy: {
    maxWidth: 480,
    paddingBottom: 12,
  },
  publicHeroEyebrow: {
    fontFamily: 'poppins-medium',
    fontSize: 14,
    lineHeight: 20,
    color: '#D5D9FF',
    marginBottom: 14,
  },
  publicHeroTitle: {
    fontFamily: 'poppins',
    fontWeight: '700',
    fontSize: 42,
    lineHeight: 52,
    color: '#FFFFFF',
    maxWidth: 440,
  },
  publicHeroText: {
    fontFamily: 'roboto-light',
    fontSize: 17,
    lineHeight: 28,
    color: 'rgba(255,255,255,0.9)',
    marginTop: 16,
    maxWidth: 430,
  },
  desktopHighlightList: {
    marginTop: 28,
  },
  desktopHighlightItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 14,
  },
  desktopHighlightDot: {
    width: 10,
    height: 10,
    borderRadius: 999,
    backgroundColor: '#CC58E3',
    marginTop: 9,
    marginRight: 12,
  },
  desktopHighlightText: {
    flex: 1,
    fontFamily: 'roboto-light',
    fontSize: 16,
    lineHeight: 24,
    color: '#FFFFFF',
  },
  mobilePublicWrap: {
    flex: 1,
    paddingHorizontal: 18,
    paddingTop: 18,
    paddingBottom: 24,
    backgroundColor: '#F7F9FC',
  },
  mobileFormCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E6EAF2',
    padding: 22,
    shadowColor: '#101828',
    shadowOpacity: 0.06,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
    elevation: 2,
  },
  mobilePublicTitle: {
    fontSize: 34,
    lineHeight: 42,
    color: '#1E2A4A',
  },
  mobilePublicSubtitle: {
    fontSize: 16,
    lineHeight: 26,
  },
  mobileInputsWrap: {
    marginTop: 20,
  },
  primaryActionMobile: {
    width: '100%',
    marginTop: 10,
  },
  mobileSecondaryAction: {
    width: '100%',
    height: 50,
    marginTop: 12,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#D9E3FB',
    backgroundColor: '#F8FBFF',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileSecondaryActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 20,
    color: '#1B2A4E',
  },
  mobileHighlightList: {
    marginTop: 18,
  },
  mobileHighlightItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  mobileHighlightDot: {
    width: 8,
    height: 8,
    borderRadius: 999,
    backgroundColor: '#CC58E3',
    marginTop: 8,
    marginRight: 10,
  },
  mobileHighlightText: {
    flex: 1,
    fontFamily: 'roboto-light',
    fontSize: 14,
    lineHeight: 22,
    color: '#667085',
  },
  termsLink: {
    color: '#6D28D9',
    fontWeight: '700',
  },
  drawerWrap: {
    marginLeft: 'auto',
    width: getPlatformType() === 'phone' ? '100%' : '50%',
    height: '100%',
    backgroundColor: 'transparent',
  },
});
